import { render } from "./SSOPropagate.vue?vue&type=template&id=f4270710"
import script from "./SSOPropagate.vue?vue&type=script&lang=js"
export * from "./SSOPropagate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__